import { Component, inject, Input, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  ModalController,
} from '@ionic/angular/standalone';
import {
  getHorlogeTotalTime,
  WPHorlogeModel,
  transformWPWeekBufferToModel,
  transformWPWeekModelToBuffer,
  VSHorlogeModel,
} from '../../../../../helper/horloge';
import { convertMinutesToTime } from '../../../../../helper/convertSecondsToTime';
import Moment from 'moment/moment';
import moment from 'moment/moment';
import { GlobalPageHeaderComponent } from '../../../../../../../components/global-page-header/global-page-header.component';
import { TranslatePipe } from '@ngx-translate/core';
import {
  getTemperature,
  getTemperatureUnit,
} from '../../../../../helper/temperature';
import {
  P00061TemperatureType,
  P00061TemperatureTypeF,
} from '../../Enum/P00061TemperatureType';

@Component({
  selector: 'app-function-parameters-settings-clock-wp',
  templateUrl: './function-parameters-settings-clock-wp.component.html',
  styleUrls: ['./function-parameters-settings-clock-wp.component.scss'],
  imports: [
    IonContent,
    GlobalPageHeaderComponent,
    TranslatePipe,
    IonButton,
    IonLabel,
    IonList,
    IonItem,
    IonModal,
    IonFooter,
  ],
})
export class FunctionParametersSettingsClockWpComponent implements OnInit {
  private modalController = inject(ModalController);

  @Input() value: string[] = ['', '', '', '', '', '', ''];
  public valueResult: string[] = ['', '', '', '', '', '', ''];

  public weekDay: number = 0;
  public horlogeModels: any = [];
  public selectModel: WPHorlogeModel | null = null;
  public selectModelStep: number = 0;

  isModalOpen = false;

  constructor() {}

  public list: any = [];
  public minuteInterval: number = 60;

  ngOnInit() {
    for (let i = 0; i < 60 * 24; i = i + this.minuteInterval) {
      this.list.push({ label: convertMinutesToTime(i), ref: i * 60 });
    }

    this.valueResult = this.value;

    this.horlogeModels = transformWPWeekBufferToModel(this.valueResult);
  }

  onCloseSelectTimeIntervalChoice(
    ref: number,
    startDate: number,
    endDate: number,
    temperature: number,
  ) {
    this.isModalOpen = false;

    if (ref == -1) {
      this.horlogeModels[this.weekDay].push({
        ref: this.horlogeModels[this.weekDay].length + 1,
        start: startDate,
        end: endDate,
        temperature: temperature,
      });
    } else {
      for (let i = 0; i < this.horlogeModels[this.weekDay].length; i++) {
        if (this.horlogeModels[this.weekDay][i].ref == ref) {
          this.horlogeModels[this.weekDay][i].start = startDate;
          this.horlogeModels[this.weekDay][i].end = endDate;
          this.horlogeModels[this.weekDay][i].temperature = temperature;
        }
      }
    }

    const buf = transformWPWeekModelToBuffer(this.horlogeModels);
    this.valueResult = buf;
    this.horlogeModels = transformWPWeekBufferToModel(buf);
  }

  secondeToHourMinute(time: number) {
    let h = Math.floor(time / (60 * 60));
    let m = Math.floor((time - h * 3600) / 60);

    return h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0');
  }

  tempsTotal() {
    const time = getHorlogeTotalTime(this.horlogeModels[this.weekDay]);
    return this.secondeToHourMinute(time);
  }

  getLeftPos(num: number) {
    return (num * 100) / (3600 * 24);
  }

  getSize(num: number) {
    return (num / (3600 * 24)) * 100;
  }

  setWeekDays(wekDay: number) {
    this.weekDay = wekDay;
  }

  onCloseSelectTimeIntervalRemove(ref: number) {
    for (let i = 0; i < this.horlogeModels[this.weekDay].length; i++) {
      if (this.horlogeModels[this.weekDay][i].ref == ref) {
        this.horlogeModels[this.weekDay].splice(i, 1);

        const buf = transformWPWeekModelToBuffer(this.horlogeModels);
        this.valueResult = buf;
        this.horlogeModels = transformWPWeekBufferToModel(buf);
        break;
      }
    }

    this.isModalOpen = false;
  }

  transformNumberToDegree(num: number) {
    return (num * 360) / (60 * 60 * 24);
  }

  selectTemperature(value: number) {
    this.selectModel!.temperature = value;
  }

  nextStep() {
    this.selectModelStep = this.selectModelStep + 1;
  }

  goToStep(step: number) {
    this.selectModelStep = step;
  }

  selectStart(value: number) {
    this.selectModel!.start = value;
  }

  selectEnd(value: number) {
    this.selectModel!.end = value;
  }

  openModal(selectModel: VSHorlogeModel | null = null) {
    if (selectModel == null) {
      let hourStr = Moment().format('HH');
      this.selectModelStep = 0;
      this.selectModel = {
        ref: -1,
        start: parseInt(hourStr) * 3600,
        end: ((parseInt(hourStr) + 1) % 24) * 3600,
        temperature: 20.0,
      };
    } else {
      this.selectModel = JSON.parse(JSON.stringify(selectModel));
      this.selectModelStep = 3;
    }

    this.isModalOpen = true;
  }

  deleteModel() {
    this.onCloseSelectTimeIntervalRemove(this.selectModel!.ref);
  }

  saveModel() {
    this.onCloseSelectTimeIntervalChoice(
      this.selectModel!.ref,
      this.selectModel!.start,
      this.selectModel!.end,
      this.selectModel!.temperature,
    );
  }

  closeModal() {
    this.isModalOpen = false;
    this.selectModel = null;
  }

  async dismissModal(): Promise<void> {
    await this.modalController.dismiss({ value: this.valueResult });
  }

  getStartDate() {
    return moment.utc(this.selectModel!.start! * 1000).format('HH:mm');
  }
  getEndDate() {
    return moment.utc(this.selectModel!.end! * 1000).format('HH:mm');
  }

  protected readonly getTemperature = getTemperature;
  protected readonly getTemperatureUnit = getTemperatureUnit;
  protected readonly P00061TemperatureTypeF = P00061TemperatureTypeF;
  protected readonly P00061TemperatureType = P00061TemperatureType;
}
